function escapeRegExp(str: string) {
    return str?.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export function replaceAll(str: string, find: string, replace: string) {
    if (!str || !find) return str;

    return str?.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}